module.exports = __webpack_public_path__ + "img/cb.7496fc87.jpg";